import { useSetRecoilState, useResetRecoilState } from 'recoil';
import { alertAtom } from '_state';

export { useAlertActions };

function useAlertActions() {
    const setAlert = useSetRecoilState(alertAtom);
    const resetAlert = useResetRecoilState(alertAtom);
    return {
        success: (message, description) => setAlert({ type: 'success', message, description }),
        error:   (message, description) => setAlert({ type: 'error', message, description }),
        clear:   resetAlert,
    };
}
